<template>
  <!-- Content Header (Page header) -->
  <div v-if="halamanloading" style="height: 100%;width: 100%; background-color: black;position:absolute;z-index: 1000;
  left: 0;top: 0;opacity: 0.75; align-content: center;color: aliceblue;text-align: center;vertical-align: middle;
  filter: progid:DXImageTransform.Microsoft.Alpha(opacity=50);background-position: center center;">
    <h1>
      <br><br><br><br><br>
      <img class="animation__shake" src="../../assets/img/logo_pu.jpg" style="height: 70px;position: center center;">
      <br><br>.. LOADING ..
    </h1>
  </div>
  <div class="content-header">
    <div class="container-fluid">
      <div class="col-md-12 text-justify">
        &nbsp;
      </div>
      <div class="row mb-2">
        <div class="col-sm-8">
          <h3><a href="/KompilasiRegister">Kompilasi OWP, AWP & Realisasi Per Proyek </a></h3>
        </div>
        <!-- /.col -->
        <div class="col-sm-4">
          <ol class="breadcrumb float-sm-right">
            <li class="breadcrumb-item active"><a href="#"><v-text-field label="Label"
                  class="form-control form-control-sm" aria-disabled="true"> Tanggal {{
                    G_formatDate(tanggalsekarang)
                  }}</v-text-field></a>
            </li>
          </ol>
        </div>
        <!-- /.col -->
      </div>
      <!-- /.row -->
    </div>
    <!-- /.container-fluid -->
  </div>
  <!-- /.content-header -->

  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12 text-justify">
          <div class="card card-warning collapsed-card">
            <div class="card-header">
              <h3 class="card-title">Filter Data</h3>

              <div class="card-tools">
                <button type="button" class="btn btn-tool" data-card-widget="collapse"><i class="fas fa-plus"></i>
                </button>
              </div>
              <!-- /.card-tools -->
            </div>
            <!-- /.card-header -->
            <div class="card-body">
              <div class="carddataputih">
                <div class="card-body">
                  <div class="row">
                    <div class="col-lg-6">
                      <label style="font-size: small;">Lender</label>
                      <v-select :options="donor" :reduce="(label) => label.code" label="label"
                        v-model="defaultSelectedDonor" @update:modelValue="onDonorChange"></v-select>
                    </div>
                    <div class="col-sm-6">
                      <label style="font-size: small;">Proyek</label>
                      <v-select :options="computeditemsDataProyek" :reduce="(label) => label.tag" label="label"
                        v-model="defaultSelectedProyek" @update:modelValue="onProyekChange"></v-select>
                    </div>
                    <div class="col-lg-6">
                      <label style="font-size: small;">Balai</label>
                      <v-select :options="balai" :reduce="(label) => label.code" label="label"
                        v-model="defaultSelectedBalai" @update:modelValue="onBalaiChange"></v-select>
                    </div>
                    <div class="col-lg-2">
                      <label style="font-size: small;">Tahun</label>
                      <v-select :options="tahun" :reduce="(label) => label.code" label="label"
                        v-model="defaultSelectedTahunMulai" @update:modelValue="onTahunChange"></v-select>
                    </div>
                    <div class="col-lg-2">
                      <label style="font-size: small;">Opsi</label>
                      <div class="col-lg-12">
                        <div class="btn-group">
                          <button type="button" class="btn btn-success btn-sm" style="width: 100%;">Export</button>
                          <button type="button" class="btn btn-success dropdown-toggle dropdown-icon"
                            data-toggle="dropdown">
                            <span class="sr-only">Toggle Dropdown</span>
                          </button>
                          <div class="dropdown-menu" role="menu">
                            <a class="dropdown-item" href="#"
                              @click="G_tableCSV('_Kompilasi_OWP_AWP_Tgl_Data_')">Excel</a>
                            <a class="dropdown-item" href="#" @click="printContent()">Print</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- /.row -->
                </div>
                <!-- /.card-body -->
              </div>
              <!-- /.cardputih -->
            </div>
            <!-- /.card-body -->
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 text-justify">
          <div class="cardputih">
            <div class="card-body">
              <div class="row">
                <div class="col-sm-4 text-justify"></div>
                <div class="col-sm-4 text-center">
                  <v-text-field label="Label" class="form-control form-control-sm" aria-disabled="true" style="background-color: #354777;
                  color:#ffffff;font-size: smaller;border-top-left-radius: 50px;border-bottom-left-radius: 50px;
                  border-top-right-radius: 50px;border-bottom-right-radius: 50px;
                  border-left: #ffc107 solid 20px;border-right: #ffc107 solid 20px;"> Tanggal Data: {{
                    G_formatDate(tanggaldata)
                  }}</v-text-field>
                </div>
                <div class="col-sm-4 text-justify"></div>
                <div class="col-sm-12 text-justify">&nbsp;</div>
                <div class="col-sm-1 text-justify">
                  <label style="font-size: small;">Pencarian</label>
                </div>
                <div class="col-sm-11 text-justify">
                  <input type="text" v-model="carikata" class="form-control form-control-sm"
                    placeholder="Masukkan Kata Kunci Pencarian">
                </div>
                <div class="col-md-12 text-justify">&nbsp;</div>
              </div>
              <div class="table-wrapper">
                <table class="table table table-bordered table-hover" id="tabeldata">
                  <thead class="cf">
                    <tr>
                      <th style="width: 50px;">No</th>
                      <th style="width: 350px;">Projek</th>
                      <th>OWP (Rp.)</th>
                      <template v-for="(year, i) in arraytahun" :key="i">
                        <th>AWP<br>Tahun {{ year.tahun }} (Rp.)</th>
                        <th>Realisasi<br>Tahun {{ year.tahun }} (Rp.)</th>
                      </template>
                      <th>Total AWP (Rp.)</th>
                      <th>Total Realisasi (Rp.)</th>
                      <th>Sisa Alokasi<br>AWP (Rp.)</th>
                      <th>Sisa Alokasi<br>Realisasi (Rp.)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="total" colspan="2">TOTAL</td>
                      <td class="totalkanan">{{ G_numFormat(totaldataowp) }}</td>
                      <template v-for="(awpfinal, urtnya) in datatotalawppertahunfinal" :key="urtnya">
                        <td class="totalkanan">{{ G_numFormat(awpfinal.totalAWP) }}</td>
                        <td class="totalkanan">{{ G_numFormat(awpfinal.totalRealisasi) }}</td>
                      </template>

                      <td class="totalkanan">{{ G_numFormat(totalsemuaawpfinal) }}</td>
                      <td class="totalkanan">{{ G_numFormat(totalsemuarealisasifinal) }}</td>
                      <td class="totalkanan">{{ G_numFormat(totaldataowp - totalsemuaawpfinal) }}</td>
                      <td class="totalkanan">{{ G_numFormat(totaldataowp - totalsemuarealisasifinal) }}</td>
                    </tr>
                  </tbody>
                  <template v-for="(dataparent, urutparent) in filteredKata" :key="urutparent">
                    <tbody>
                      <tr>
                        <td class="kolomsatkerkanan">{{ urutparent + 1 }}</td>
                        <td class="kolomsatker">{{ dataparent.projekId }}-{{ dataparent.projekNm }}</td>
                        <td class="kolomsatkerkanan">{{ G_numFormat(dataparent.OWP) }}</td>
                        <template v-for="(year, i) in arraytahun" :key="i">
                          <td class="kolomsatkerkanan">
                            <span v-for="(dataAWP, urutAWP) in dataparent.AWP " :key="urutAWP">
                              <span v-if="dataAWP.tahun == year.tahun">
                                {{ G_numFormat(dataAWP.nilaiawp) }}
                              </span>
                            </span>
                          </td>
                          <td class="kolomsatkerkanan">
                            <span v-for="(dataRealisasi, urutReal) in dataparent.Realisasi " :key="urutReal">
                              <span v-if="dataRealisasi.tahun == year.tahun">
                                {{ G_numFormat(dataRealisasi.nilairealisasi) }}
                              </span>
                            </span>
                          </td>
                        </template>
                        <td class="kolomsatkerkanan">{{ G_numFormat(dataparent.Nilaitotalawpproyek) }}</td>
                        <td class="kolomsatkerkanan">{{ G_numFormat(dataparent.Nilaitotalrealisasiproyek) }}</td>
                        <td class="kolomsatkerkanan">{{ G_numFormat(dataparent.OWP - dataparent.Nilaitotalawpproyek) }}
                        </td>
                        <td class="kolomsatkerkanan">{{ G_numFormat(dataparent.OWP - dataparent.Nilaitotalrealisasiproyek)
                        }}</td>
                      </tr>
                    </tbody>
                  </template>

                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /.container-fluid -->
  </div>
  <!-- /.content -->
</template>
    
<script>
import $ from 'jquery';
import axios from "axios";
//import Vueaxios from "vue-axios";
import vSelect from 'vue-select';
import "datatables.net-bs4";
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css";
import "datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css";
import xlsx from 'xlsx/dist/xlsx.full.min';

//import { Doughnut } from "vue-chartjs";
//import Chart from 'chart.js'

export default {
  components: {
    vSelect,
  },
  data() {
    return {
      carikata: '',
      cekbalai: [],
      halamanloading: true,

      defaultSelectedSumberDana: {
        code: 0,
        label: 'PHLN'
      },
      SumberDana: [
        { code: 0, label: 'PHLN' }, { code: 1, label: 'SBSN' }
      ],
      hasLoanOnlyfiler: true,
      hasSbsnOnlyfilter: false,

      defaultSelectedDonor: {
        code: "0",
        label: "Semua Lender"
      },
      kddonorfilter: "",
      datamasterdonor: [],
      donor: [],

      defaultSelectedProyek: {
        code: "0",
        label: "Semua Proyek",
        tag: ""
      },
      kdProyekfilter: "",
      datamasterProyek: [],
      Proyek: [],

      defaultSelectedRegister: {
        code: "0",
        label: "Semua Register"
      },
      koderegisterfilter: "",
      register: [],
      defaultSelectedTahunMulai: {
        code: 0,
        label: localStorage.getItem("TahunAktif"),
      },
      defaultSelectedTahun: {
        code: 0,
        label: localStorage.getItem("TahunAktif"),
      },
      tahundata: new Date().getFullYear(),
      tahunmulaifilter: localStorage.getItem("TahunAktif"),
      tahunmulaiselesaifilter: localStorage.getItem("TahunAktif"),
      tahunfilter: localStorage.getItem("TahunAktif"),
      datatahun: [],
      tahun: [],

      defaultSelectedBalai: {
        code: "0",
        label: "Semua Balai"
      },
      kdbalaifilter: "",
      datamasterbalai: [],
      balai: [],

      defaultSelectedDetailSatker: {
        code: 0,
        label: 'Tidak'
      },
      DetailSatker: [
        { code: 0, label: 'Tidak' }, { code: 1, label: 'Ya' }
      ],
      detailsatkerfilter: false,

      ///// rekap
      data: [],
      datarekap: [],
      tanggaldata: '',
      totalpagu: '0',
      totalrealisasi: '0',
      totalrata2keu: '0',
      totalrata2fisik: '0',
      rata2keu: '0',
      rata2fisik: '0',
      datatabel: [],
      datatabelsatker: [],
      arraytahun: [],
      datarealisasi: 0,
      datakoreksi: 0,
      datahasil: 0,
      listItems: [],
      datamastertabelowp: [],
      datadetailtabelowp: [],
      totaldataowp: 0,
      totaltabelowp: 0,
      totaltabelawp: 0,
      caridataowp: [],
      caridataawp: [],
      dataawp: [],
      datdetailaawp: [],
      dataisidetailaawp: [],
      hasilcaridataawp: [],
      totalawppertahun: 0,
      datatotalawppertahun: [],
      datatotalawppertahunfinal: [],
      totalsemuaawpfinal: 0,
      datakompilasi: [],
      datakompilasidetail: [],
      caridatarealisasi: [],
      hasilcaridatarealisasi: [],
      totalrealisasipertahun: 0,
      datatotalrealisasipertahun: [],
      datatotalrealisasipertahunfinal: [],
      totalsemuarealisasifinal: 0,
      cektahunawal: [],
      datacektahunawal: [],

      framework: [],
      tanggalsekarang: new Date(),
    }
  },
  computed: {
    computeditemsDataProyek: function () {
      return this.Proyek.filter(function (item) {
        return item.label != "TEST-Test Edit" && item.label != "Test Edit";
      })
    },
    filteredKata() {
      const filteredWorkers = this.carikata === ""
        ? this.datatabel
        : this.datatabel.filter(wo => Object.values(wo).join("").toLowerCase().indexOf(this.carikata.toLowerCase()) !== -1);
      return filteredWorkers;
    },
  },
  methods: {
    printContent() {
      var divToPrint = document.getElementById('tabeldata');
      var htmlToPrint = '' +
        '<style type="text/css">' +
        'table th, table td {' +
        'border:1px solid #000;' +
        '}' +
        '</style>';
      htmlToPrint += divToPrint.outerHTML;
      const printWindow = window.open('', '', 'height=1000,width=1000')
      printWindow.document.write(htmlToPrint)
      printWindow.print()

    },
    async G_tableCSV(namefile) {
      this.framework = [];
      this.halamanloading = true;
      for (let i = 0; i < this.filteredKata.length; i++) {
        this.framework.push({
          "No": i + 1,
          "Projek": this.filteredKata[i].projekId,
          "Nama Proyek": this.filteredKata[i].projekNm,
          "OWP (Rp.)": this.filteredKata[i].OWP,
          "AWP (Rp.)": this.filteredKata[i].Nilaitotalawpproyek,
          "Realisasi (Rp.)": this.filteredKata[i].Nilaitotalrealisasiproyek,
          "Sisa ALokasi AWP (Rp.)": this.filteredKata[i].OWP - this.filteredKata[i].Nilaitotalawpproyek,
          "Sisa ALokasi Realisasi (Rp.)": this.filteredKata[i].OWP - this.filteredKata[i].Nilaitotalrealisasiproyek,
        })
      }

      function formatColumn(worksheet, col, fmt) {
        const range = XLSX.utils.decode_range(worksheet['!ref'])
        // note: range.s.r + 1 skips the header row
        for (let row = range.s.r + 1; row <= range.e.r; ++row) {
          const ref = XLSX.utils.encode_cell({ r: row, c: col })
          if (worksheet[ref] && worksheet[ref].t === 'n') {
            worksheet[ref].z = fmt
          }
        }
      }
      const currency = '0.00';

      const XLSX = xlsx;
      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet(this.framework);

      for (let col of [2, 3, 4, 5, 6, 7]) {
        formatColumn(worksheet, col, currency)
      }

      XLSX.utils.book_append_sheet(workbook, worksheet, "framework");
      XLSX.writeFile(workbook, this.G_formatDate(Date(), 'd-M-Y') + namefile + this.G_formatDate(this.tanggaldata) + ".xlsx");
      this.halamanloading = false;



    },
    onRegisterChange(a) {
      let selectedIsi = this.register[a].tag;
      let filter = selectedIsi;
      this.koderegisterfilter = "";
      if (filter != 'Semua Register') { this.koderegisterfilter = filter }
      this.ambildataUpdate();
    },
    onProyekChange(a) {
      //console.log(a);
      let selectedIsi = a;
      let filter = selectedIsi;
      this.kdProyekfilter = "";
      if (filter != 'Semua Proyek') { this.kdProyekfilter = filter }
      //console.log(this.kdProyekfilter);
      this.ambildataUpdate();
    },
    onBalaiChange(a) {
      let selectedIsi = this.balai[a].code;
      this.kdbalaifilter = "";
      if (selectedIsi != 0) { this.kdbalaifilter = selectedIsi }
      this.ambildataUpdate();
    },
    onDonorChange(a) {
      let selectedIsi = this.donor[a].label;
      this.kddonorfilter = "";
      if (selectedIsi != 'Semua Lender') { this.kddonorfilter = selectedIsi }
      //console.log(this.kddonorfilter)
      this.ambildataUpdate();
    },
    onSumberDanaChange(a) {
      let selectedIsi = this.SumberDana[a].code;
      this.hasLoanOnlyfiler = true;
      this.hasSbsnOnlyfilter = false;
      if (selectedIsi == 1) { this.hasLoanOnlyfiler = false; this.hasSbsnOnlyfilter = true; }
      this.ambildataUpdate();
    },
    onDetailSatkerChange(a) {
      let selectedIsi = this.DetailSatker[a].code;
      this.detailsatkerfilter = false;
      if (selectedIsi == 1) { this.detailsatkerfilter = true; }
      this.RubahData();
    },
    onTahunMulaiChange(a) {
      let selectedtahun = this.tahun[a].label;
      this.tahunmulaifilter = selectedtahun;
      this.ambildataUpdate();
    },
    onTahunChange(a) {
      let selectedtahun = this.tahun[a].label;
      this.tahunfilter = selectedtahun;
      this.ambildataUpdate();
    },
    initializeSelect2() {
      //Initialize Select2 Elements
      $(".select2").select2();

      //Initialize Select2 Elements
      $(".select2bs4").select2({
        theme: "bootstrap4",
      });
    },
    async AmbilDataDonor() {
      this.halamanloading = true;
      JSON.parse(localStorage.getItem("userLogin"));
      const mainAPIMaster = axios.create({
        baseURL: process.env.VUE_APP_URL_API,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });
      await mainAPIMaster.get("reff/donor")
        .then(
          Response => {
            //console.log(Response.data);
            this.datamasterdonor = Response.data;
            //console.log(this.datamasterdonor);
            this.datamasterdonor.forEach((item) => {
              this.donor.push({
                label: item,
                code: this.datamasterdonor.indexOf(item) + 1,
              });
            });
            this.donor.unshift({
              label: 'Semua Lender',
              code: '0',
            });
            //console.log(this.donor);
            this.tanggaldata = new Date();
            this.halamanloading = false;
          }
        ).catch(error => {
          console.log(error);
          this.halamanloading = false;
          window.location.replace("/");
        })
    },
    async AmbilDataAPI() {
      this.halamanloading = true;
      JSON.parse(localStorage.getItem("userLogin"));
      const mainAPIRekap = axios.create({
        baseURL: process.env.VUE_APP_URL_API,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });
      await mainAPIRekap.get("progres/rekap/per-proyek?tahun=" + this.tahunfilter + "&proyek=" + this.kdProyekfilter +
        "&hasLoanOnly=true&hasSbsnOnly=false&lender=" + this.kddonorfilter
        + "&kdbalai=" + this.kdbalaifilter)
        .then(
          Response => {
            this.cektahunawal = Response.data.content;
            this.cektahunawal.forEach((item) => {
              mainAPIRekap.get("reff/register?projekId=" + item.projekId)
                .then(
                  Response => {
                    this.datacektahunawal = Response.data.content;
                    this.datacektahunawal.forEach((item) => {
                      if (this.G_AmbilTahun(item.tanggalEfektif) < this.tahunmulaifilter) {
                        this.tahunmulaifilter = this.G_AmbilTahun(item.tanggalEfektif);
                        //console.log("Coba: "+this.tahunmulaifilter);
                      }
                    })
                  }
                ).catch()
            })
          }
        ).catch()
      await axios.get("https://pmisv2.sisda.net/api/master/awp/get/all/loan").then(
        Response => {
          this.listItems = Response.data.data.Data;
          this.listItems.forEach((item) => {
            this.dataawp.push({
              tahun_awp: item.tahun_awp,
            });
          })
          this.dataawp.sort((a, b) => {
            //this.halamanloading = false;
            return a.tahun_awp - b.tahun_awp;
          });
          //this.tahunmulaifilter = 2012;
          this.tahunmulaiselesaifilter = this.dataawp[this.dataawp.length - 1].tahun_awp;
        }).catch()
      //console.log(this.tahunmulaifilter);
      this.dataisidetailaawp = [];
      for (let x = this.tahunmulaifilter; x <= this.tahunmulaiselesaifilter; x++) {
        this.halamanloading = true;
        await this.AmbilDataAWP(x);
        this.arraytahun.push({
          tahun: x,
        });
      }

      await this.AmbilDataOWP();
      await this.ambildataUpdate();
      this.halamanloading = false;
      //console.log(this.tahunmulaiselesaifilter);
    },
    async AmbilDataAWP(tahun) {
      this.halamanloading = true;
      this.tahundata = tahun;
      JSON.parse(localStorage.getItem("userLogin"));
      this.cekbalai = JSON.parse(localStorage.getItem("userLogin"));
      const mainAPIMaster = axios.create({
        baseURL: process.env.VUE_APP_URL_API,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });
      await mainAPIMaster.get("awp/rekap/per-proyek?tahun=" + tahun)
        .then(Response => {
          this.datdetailaawp = Response.data.content;
          this.datdetailaawp.forEach((item) => {
            this.dataisidetailaawp.push({
              projekId: item.projekId,
              tahun: this.tahundata,
              nilaiawp: item.awp,
            })
            this.halamanloading = false;
          })
        }).catch(error => {
          console.log(error);
          this.halamanloading = false;
        })

      await mainAPIMaster.get("progres/rekap/per-proyek?tahun=" + tahun + "&hasLoanOnly=true&hasSbsnOnly=false")
        .then(Response => {
          this.datakompilasi = Response.data.content;
          this.datakompilasi.forEach((item) => {
            this.datakompilasidetail.push({
              projekId: item.projekId,
              tahun: this.tahundata,
              nilairealisasi: item.rtot,
            })
            this.halamanloading = false;
          })
        }).catch(error => {
          console.log(error);
          this.halamanloading = false;
        })
    },
    async AmbilDataBalai() {
      this.halamanloading = true;
      JSON.parse(localStorage.getItem("userLogin"));
      this.cekbalai = JSON.parse(localStorage.getItem("userLogin"));
      const mainAPIMaster = axios.create({
        baseURL: process.env.VUE_APP_URL_API,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });
      await mainAPIMaster.get("reff/balai")
        .then(
          Response => {
            //console.log(Response.data);
            this.datamasterbalai = Response.data.content;
            //console.log(this.datamasterdonor);
            this.datamasterbalai.forEach((item) => {
              this.balai.push({
                label: item.nmbalai,
                code: item.kdbalai,
              });
            });
            if (this.cekbalai.kdbalai == null) {
              this.balai.unshift({
                label: 'Semua Balai',
                code: '0',
              });
            }
            else {
              this.defaultSelectedBalai = this.balai;
              //this.selectedbalai = this.balai[0].label;
              this.kdbalaifilter = this.balai[0].code;
              //console.log("Balai"+this.selectedbalai);
            }
            //console.log(this.donor);
            //this.halamanloading = false;
          }
        ).catch(error => {
          console.log(error);
          this.halamanloading = false;
          window.location.replace("/");
        })
    },
    async AmbilDataTahun() {
      this.halamanloading = true;
      JSON.parse(localStorage.getItem("userLogin"));
      const mainAPITahun = axios.create({
        baseURL: process.env.VUE_APP_URL_API,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });
      await mainAPITahun.get("progres/tahun")
        .then(
          Response => {
            this.datatahun = Response.data.content;
            //console.log(this.datatahun);
            //this.selected = document.getElementById('pilihantahun').options[0].text;
            this.datatahun.forEach((item) => {
              this.tahun.push({
                label: item,
                code: this.datatahun.indexOf(item),
              });
            });
            this.halamanloading = false;
          }
        ).catch(error => {
          console.log(error);
          this.halamanloading = false;
          //window.location.replace("/");
        });
    },
    async AmbilDataOWP() {
      this.halamanloading = true;
      JSON.parse(localStorage.getItem("userLogin"));
      const mainAPIMaster = axios.create({
        baseURL: process.env.VUE_APP_URL_API,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });
      await mainAPIMaster.get("owp/rekap").then(
        Response => {
          this.datamastertabelowp = Response.data.content;
          this.datamastertabelowp.forEach((item) => {
            this.datadetailtabelowp.push({
              projekId: item.projekId,
              lender: item.lender,
              totalOwp: item.totalOwp,
              piu: item.piu,
              balai: item.balai,
            })
          })
        }
      ).catch(error => {
        console.log(error);
        this.halamanloading = false;
        window.location.replace("/");
      })
    },
    async AmbilDataProyek() {
      this.halamanloading = true;
      JSON.parse(localStorage.getItem("userLogin"));
      const mainAPIMaster = axios.create({
        baseURL: process.env.VUE_APP_URL_API,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });
      await mainAPIMaster.get("reff/proyek")
        .then(
          Response => {
            //console.log(Response.data);
            this.datamasterProyek = Response.data.content;
            //console.log(this.datamasterProyek);
            this.datamasterProyek.forEach((item) => {
              this.Proyek.push({
                label: item.projekId + '-' + item.projekNm,
                code: this.datamasterProyek.indexOf(item) + 1,
                tag: item.projekId,
              });
            });
            this.Proyek.unshift({
              label: 'Semua Proyek',
              code: '0',
              tag: '',
            });
            //console.log(this.Proyek);
            //this.halamanloading = false;
          }
        ).catch(error => {
          console.log(error);
          this.halamanloading = false;
          //window.location.replace("/");
        })
    },
    async ambildataUpdate() {
      this.halamanloading = true;
      //await this.AmbilDataBalai();
      JSON.parse(localStorage.getItem("userLogin"));
      const mainAPIRekap = axios.create({
        baseURL: process.env.VUE_APP_URL_API,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });
      await mainAPIRekap.get("progres/rekap/per-proyek?tahun=" + this.tahunfilter + "&proyek=" + this.kdProyekfilter +
        "&hasLoanOnly=true&hasSbsnOnly=false&lender=" + this.kddonorfilter
        + "&kdbalai=" + this.kdbalaifilter)
        .then(
          Response => {
            this.datatabel = [];
            this.datarekap = Response.data.content;
            this.totalpagu = this.datarekap.reduce((a, { pg: e }) => a + e, 0);
            this.totalrealisasi = this.datarekap.reduce((a, { rtot: e }) => a + e, 0);
            //console.log("Total: "+this.totalpagu);
            //console.log("Total: "+this.totalrealisasi);
            this.totalrata2keu = this.datarekap.reduce((a, { keuPrs: e }) => a + e, 0);
            this.totalrata2fisik = this.datarekap.reduce((a, { fisikPrs: e }) => a + e, 0);
            const jumlahdata = this.datarekap.length;
            if (jumlahdata != 0) {
              this.rata2keu = this.totalrata2keu / jumlahdata;
              this.rata2fisik = this.totalrata2fisik / jumlahdata;
            }
            if (this.totalpagu == 0) {
              this.rata2keu = 0;
              this.rata2fisik = 0;
            }
            this.totaldataowp = 0;
            this.datarekap.forEach((item) => {
              this.totalowp = 0;
              this.caridataowp = this.datadetailtabelowp.filter((element) => element.projekId == item.projekId);
              this.totalowp = this.caridataowp.reduce((a, { totalOwp: e }) => a + e, 0);
              if (this.caridataowp.length == 0) {
                this.totalowp = 0;
              }
              this.totaldataowp = this.totaldataowp + this.totalowp;
              this.caridataawp = [];
              for (let i = 0; i < this.arraytahun.length; i++) {
                for (let x = 0; x < this.dataisidetailaawp.length; x++) {
                  this.hasilcaridataawp = this.dataisidetailaawp.filter((element) => ((element.projekId == item.projekId)
                    && (element.tahun == this.arraytahun[i].tahun)));
                  if (this.hasilcaridataawp.length == 0) {
                    this.hasilcaridataawp = this.listItems.filter((element) => ((element.project_name == item.projekId)
                      && (element.tahun_awp == this.arraytahun[i].tahun)));
                    if (this.hasilcaridataawp.length == 0) {
                      this.dataisidetailaawp.push({
                        projekId: item.projekId,
                        tahun: this.arraytahun[i].tahun,
                        nilaiawp: 0,
                      })
                    }
                    else {
                      let totalawppmis = this.hasilcaridataawp.reduce((a, { total_awp: e }) => a + e, 0);
                      this.dataisidetailaawp.push({
                        projekId: item.projekId,
                        tahun: this.arraytahun[i].tahun,
                        nilaiawp: totalawppmis,
                      })
                    }
                  }
                }
              }

              this.caridatarealisasi = [];
              for (let i = 0; i < this.arraytahun.length; i++) {
                for (let x = 0; x < this.datakompilasidetail.length; x++) {
                  this.hasilcaridatarealisasi = this.datakompilasidetail.filter((element) => ((element.projekId == item.projekId)
                    && (element.tahun == this.arraytahun[i].tahun)));
                  if (this.hasilcaridatarealisasi.length == 0) {
                    this.datakompilasidetail.push({
                      projekId: item.projekId,
                      tahun: this.arraytahun[i].tahun,
                      nilairealisasi: 0,
                    })
                  }
                }
              }

              this.caridataawp = this.dataisidetailaawp.filter((element) => element.projekId == item.projekId);
              this.caridatarealisasi = this.datakompilasidetail.filter((element) => element.projekId == item.projekId);

              let totalawpproyek = this.caridataawp.reduce((a, { nilaiawp: e }) => a + e, 0);
              let totalrealisasiproyek = this.caridatarealisasi.reduce((a, { nilairealisasi: e }) => a + e, 0);
              this.datatabel.push({
                projekId: item.projekId,
                registerId: item.registerId,
                projekNm: item.projekNm,
                pg: item.pg,
                rtot: item.rtot,
                keuPrs: item.keuPrs,
                fisikPrs: item.fisikPrs,
                OWP: this.totalowp,
                AWP: this.caridataawp,
                Realisasi: this.caridatarealisasi,
                Nilaitotalawpproyek: totalawpproyek,
                Nilaitotalrealisasiproyek: totalrealisasiproyek,
              })

            })
            //console.log("Rata2: "+this.rata2keu );
            this.datatabel.sort((a, b) => {
              //this.halamanloading = false;
              return b.OWP - a.OWP;
            });
            for (let n = 0; n < this.arraytahun.length; n++) {
              for (let i = 0; i < this.datatabel.length; i++) {
                this.totalawppertahun = 0;
                this.totalrealisasipertahun = 0;
                for (let x = 0; x < this.datatabel[i].AWP.length; x++) {
                  if (this.datatabel[i].AWP[x].tahun == this.arraytahun[n].tahun) {
                    this.totalawppertahun = this.totalawppertahun + this.datatabel[i].AWP[x].nilaiawp;
                    this.datatotalawppertahun.push({
                      totaltahun: this.arraytahun[n].tahun,
                      totalAWP: this.datatabel[i].AWP[x].nilaiawp || 0,
                    })
                  }
                  if (this.datatabel[i].Realisasi[x].tahun == this.arraytahun[n].tahun) {
                    this.totalrealisasipertahun = this.totalrealisasipertahun + this.datatabel[i].Realisasi[x].nilairealisasi;
                    this.datatotalrealisasipertahun.push({
                      totaltahun: this.arraytahun[n].tahun,
                      totalRealisasi: this.datatabel[i].Realisasi[x].nilairealisasi || 0,
                    })
                  }
                }
              }
            }

            this.datatotalawppertahunfinal = [];
            for (let n = 0; n < this.arraytahun.length; n++) {
              let hasiltotalawp = this.datatotalawppertahun.filter((element) => element.totaltahun == this.arraytahun[n].tahun);
              let totalawp = hasiltotalawp.reduce((a, { totalAWP: e }) => a + e, 0);
              let hasiltotalrealisasi = this.datatotalrealisasipertahun.filter((element) => element.totaltahun == this.arraytahun[n].tahun);
              let totalrealisasi = hasiltotalrealisasi.reduce((a, { totalRealisasi: e }) => a + e, 0);
              this.datatotalawppertahunfinal.push({
                totaltahun: this.arraytahun[n].tahun,
                totalAWP: totalawp || 0,
                totalRealisasi: totalrealisasi || 0,
              })
            }

            this.datatotalrealisasipertahunfinal = [];
            for (let n = 0; n < this.arraytahun.length; n++) {
              let hasiltotalrealisasi = this.datatotalrealisasipertahun.filter((element) => element.totaltahun == this.arraytahun[n].tahun);
              let totalrealisasi = hasiltotalrealisasi.reduce((a, { totalRealisasi: e }) => a + e, 0);
              this.datatotalrealisasipertahunfinal.push({
                totaltahun: this.arraytahun[n].tahun,
                totalRealisasi: totalrealisasi || 0,
              })
            }

            this.totalsemuaawpfinal = this.datatotalawppertahunfinal.reduce((a, { totalAWP: e }) => a + e, 0);
            this.totalsemuarealisasifinal = this.datatotalrealisasipertahunfinal.reduce((a, { totalRealisasi: e }) => a + e, 0);
            this.tanggaldata = Response.data.tanggalEmon;
            this.halamanloading = false;
          }
        ).catch(error => {
          console.log(error);
          this.halamanloading = false;
          //window.location.replace("/");
        });
    },
  },
  created() {
    this.halamanloading = true;
  },
  beforeMount() {
    this.halamanloading = true;
  },
  mounted() {
    this.initializeSelect2();
    this.AmbilDataDonor();
    this.AmbilDataTahun();
    this.AmbilDataProyek();
    this.AmbilDataBalai();
    this.AmbilDataAPI();
    document.getElementById('DashboardGrup').className = 'nav-item menu-open';
    document.getElementById('MonitoringGrup').className = 'nav-item menu-close';
    document.getElementById('PaketPipeLineGrup').className = 'nav-item menu-close';
    document.getElementById('PaketKontraktualGrup').className = 'nav-item menu-close';
    document.getElementById('PrognosisGrup').className = 'nav-item menu-close';
    document.getElementById('KendalaGrup').className = 'nav-item menu-close';
    document.getElementById('AWPGrup').className = 'nav-item menu-close';
    document.getElementById('PengecekanGrup').className = 'nav-item menu-close';
    document.getElementById('FormIsianGrup').className = 'nav-item menu-close';
    document.getElementById('KompilasiGrup').className = 'nav-item menu-open';
    document.getElementById('ADKGrup').className = 'nav-item menu-close';
    document.getElementById('ManajemenGrup').className = 'nav-item menu-close';
    document.getElementById('bodyLMS').className = 'hold-transition sidebar-mini layout-fixed';
    const sidebar = document.querySelector('aside');
    sidebar.style.display = 'block';
    const nav = document.querySelector('nav');
    nav.style.visibility = 'visible';
    //document.getElementById('Atas').style.visibility = 'visible';
    const footer = document.querySelector('footer');
    footer.style.visibility = 'visible';

  },
};
</script>
    
<style></style>